import Bloc from './Bloc.js';
import Types from './Types.js';

export default class ReviveCleanup extends Bloc {

	constructor (src, ctx) {

		super("revivecleanup", src, ctx, true);
		this.f = (src, ins) => {
			if (!ins[0].id || ins[0].id.type !== "enemy")
				return [];

			ins[0].loseIntent();
			ins[0].statuses.slice().forEach(status => {
				if (!status.model.postmortem)
					status.dissipate();
			});
			return [];
		};
		this.types = [Types.entity];
	}
}
